module.exports = __webpack_public_path__ + "static/media/maximize.68dd14bf.svg";